module.exports = __webpack_public_path__ + "img/company25.6f3b6186.png";